import { forwardRef } from 'react'

import type { ReactElement, ReactNode, Ref, TextareaHTMLAttributes } from 'react'

import BasicTextArea from '../../Basic/TextArea'
import Wrapper from '../Wrapper'

export interface Props extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  className?: string
  error?: ReactNode
  label?: string
  labelPosition?: 'top' | 'left'
  name: string
  resizable?: boolean
  value?: string
}

const TextArea = forwardRef(({ className, error, ...props }: Props, ref: Ref<HTMLTextAreaElement>): ReactElement => {
  return (
    <Wrapper className={className} error={error}>
      <BasicTextArea {...props} ref={ref} />
    </Wrapper>
  )
})

TextArea.displayName = 'TextArea'

export default TextArea
